import React, { useState } from "react";
import {
  Row,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  FormFeedback,
  Spinner
} from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";

import { connect } from "react-redux";
import { addProvince } from "../../actions/provinces";

import ElementWrapper from "../styles/ElementWrapper";
import PageTransition from "../styles/PageTransition";
import ContainerHeader from "../styles/ContainerHeader";
import PanelNavs from "../PanelNavs";
import PrimaryBtn from "../PrimaryBtn";
import GooglePlacesField from "../GooglePlacesField";
import Map from "../Map";

const ProvincesCreate = ({ addProvince, history }) => {
  const [latLong, setLatLong] = useState({
    lat: 0,
    lng: 0
  });

  return (
    <PageTransition>
      <Container>
        <ContainerHeader>
          <PanelNavs title="Nueva Provincia" />
        </ContainerHeader>
        <Row className="mb-5">
          <Col sm={6}>
            <ElementWrapper className="p-3">
              <Formik
                initialValues={{
                  name: "",
                  address: "",
                  lat: "",
                  lon: "",
                  country_id: 1
                }}
                onSubmit={async (values, { setSubmitting }) => {
                  const newValues = {
                    name: values.name,
                    lat: values.lat,
                    lon: values.lon,
                    country_id: values.country_id
                  };

                  const response = await addProvince(newValues);

                  if (response !== 200) {
                    setSubmitting(false);
                    return;
                  }

                  setSubmitting(false);
                  history.push(`/provinces`);
                }}
                validationSchema={Yup.object().shape({
                  name: Yup.string().required("Requerido."),
                  address: Yup.string().required("Requerido.")
                })}
                render={({
                  values,
                  touched,
                  errors,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  setFieldValue
                }) => {
                  const handleAddressSelect = async place => {
                    setFieldValue("address", place);
                    const results = await geocodeByAddress(place);
                    const { lat, lng } = await getLatLng(results[0]);

                    setLatLong({
                      ...latLong,
                      lat,
                      lng
                    });

                    setFieldValue("lat", lat);
                    setFieldValue("lon", lng);
                  };

                  return (
                    <Form>
                      <fieldset
                        disabled={isSubmitting}
                        aria-busy={isSubmitting}
                      >
                        <FormGroup>
                          <Label for="name">Nombre:</Label>
                          <Input
                            id="name"
                            type="text"
                            placeholder="Ingrese nombre de la provincia"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className={`${errors.name &&
                              touched.name &&
                              "is-invalid"}`}
                          />
                          {errors.name && touched.name && (
                            <FormFeedback className="d-block">
                              {errors.name}
                            </FormFeedback>
                          )}
                        </FormGroup>

                        <GooglePlacesField
                          label="Dirección:"
                          setFieldValue={setFieldValue}
                          value={values.address}
                          onSelect={handleAddressSelect}
                          errors={errors}
                          touched={touched}
                        />

                        <FormGroup>
                          <PrimaryBtn type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <Spinner size="sm" /> : "Guardar"}
                          </PrimaryBtn>
                        </FormGroup>
                      </fieldset>
                    </Form>
                  );
                }}
              />
            </ElementWrapper>
          </Col>
          <Col sm={6}>
            <Map center={latLong} zoom={15} />
          </Col>
        </Row>
      </Container>
    </PageTransition>
  );
};

export default connect(
  null,
  {
    addProvince
  }
)(ProvincesCreate);
